import Lang from "../../userPreferences/staticWords";
import * as Yup from "yup";
import community from "./../../API/store/reducers/community";
export const formikValidation = (touched, errors, fieldName) => {
  return touched[fieldName] && errors[fieldName] ? errors[fieldName] : false;
};

export const validationSchema = () => {
  return {
    search: {
      TaskStatus: Yup.number(),
    },
    createNewTask: {
      Name: Yup.string().required(Lang.require),
      Description: Yup.string().required(Lang.require),
      StartDate: Yup.date(),
      EndDate: Yup.date(),
      ActualStartDate: Yup.date(),
      ActualEndDate: Yup.date(),
      EstimatedTime: Yup.number().nullable(),
      PriorityId: Yup.string().required(Lang.require),
      TaskStatusId: Yup.string().required(Lang.require),
      AdminTaskMembers: Yup.number().required(Lang.require),
      TaskMembers: Yup.array().nullable(),
      files: Yup.array(),
      ExecutionPercentage: Yup.number().nullable(),
      file: Yup.string(),
      CommunityId: Yup.string().required(Lang.require), //.required(Lang.require),
      AccessLevelId: Yup.string().nullable(), //.required(Lang.require),
      TypeId: Yup.string().required(Lang.require), //.required(Lang.require),
      // SectorId: Yup.string(),
      typeId: Yup.string().required(Lang.require),
      Countries: Yup.array().min(1, Lang.require).required(Lang.require),
      TaskImplementRequirementId: Yup.string().required(Lang.require),
    },
    createNewSubTask: {
      Name: Yup.string().required(Lang.require),
      Description: Yup.string().nullable(),
      StartDate: Yup.date().required(Lang.require),
      EndDate: Yup.date().required(Lang.require),
      EstimatedTime: Yup.number().nullable(),
      TaskStatusId: Yup.string().required(Lang.require),
      AdminTaskMembers: Yup.array(),
      TaskMembers: Yup.array().nullable(),
      files: Yup.array(),
      ExecutionPercentage: Yup.number().nullable(),
      file: Yup.string(),
    },
    addProcedure: {
      Description: Yup.string().required(Lang.require),
      files: Yup.array(), //.required(Lang.require),
      file: Yup.string(),
      StartDate: Yup.date(),
      //EndDate: Yup.date(),
      tempUser: Yup.string(),
      //TaskStatusId: Yup.number(),
      // UserId:Yup.string()
    },
    addActivityProcedure: {
      Description: Yup.string().required(Lang.require),
      files: Yup.array().required(Lang.require),
      file: Yup.string(),
      StartDate: Yup.date().required(Lang.require),
      EndDate: Yup.date().required(Lang.require),
      tempUser: Yup.string(),
      ActivityStatusId: Yup.number().required(Lang.require),
    },
    editSubTaskPopup: {
      Name: Yup.string().required(Lang.require),
      Description: Yup.string().nullable(),
      StartDate: Yup.date().required(Lang.require),
      EndDate: Yup.date().required(Lang.require),
      EstimatedTime: Yup.number().nullable(),
      TaskStatusId: Yup.string().required(Lang.require),
      AdminTaskMembers: Yup.array(),
      TaskMembers: Yup.array().nullable(),
      ExecutionPercentage: Yup.number().nullable(),
    },
    editPopup: {
      Name: Yup.string().required(Lang.require),
      Description: Yup.string().required(Lang.require),
      StartDate: Yup.date().required(Lang.require),
      EndDate: Yup.date().required(Lang.require),
      ActualStartDate: Yup.date(),
      ActualEndDate: Yup.date(),
      EstimatedTime: Yup.number().nullable(),
      PriorityId: Yup.string().required(Lang.require),
      TaskStatusId: Yup.string().required(Lang.require),
      AdminTaskMembers: Yup.number()
        .moreThan(0, Lang.require)
        .required(Lang.require),
      TaskMembers: Yup.array().nullable(),
      ExecutionPercentage: Yup.number().nullable(),
      CommunityId: Yup.string().required(Lang.require), //.required(Lang.require),
      AccessLevelId: Yup.string(), //.required(Lang.require),
      // SectorI;d: Yup.string().required(Lang.require),
      typeId: Yup.string().required(Lang.require),
      CountrisId: Yup.array().min(1, Lang.require).required(Lang.require),
      TaskImplementRequirementId: Yup.string().required(Lang.require),
    },
    addAttachment: {
      AttachmentFiles: Yup.array().required(Lang.require),
      file: Yup.string(),
    },
    editProc: {
      Id: Yup.string().required(Lang.require),
      StartDate: Yup.date().required(Lang.require),
      EndDate: Yup.date().required(Lang.require),
      Description: Yup.string().required(Lang.require),
      UserId: Yup.string(),
    },
    posts: {
      Title: Yup.string().required(Lang.require),
      Description: Yup.string().required(Lang.require),
      Attachment: Yup.string(),
    },
    profilePosts: {
      Title: Yup.string().required(Lang.require),
      Description: Yup.string().required(Lang.require),
      Attachment: Yup.string(),
    },
    editProfilePosts: {
      Title: Yup.string().required(Lang.require),
      Description: Yup.string().required(Lang.require),
    },
    //forum edit
    editForum: {
      Id: Yup.number(),
      Title: Yup.string().required(Lang.require),
      Description: Yup.string().required(Lang.require),
    },
  };
};

export const initialValues = (pageData) => {
  return {
    search: {
      TaskStatus: pageData?.taskStatusSearch ?? 5,
    },
    createNewTask: {
      Name: "",
      Description: "",
      StartDate: new Date().toISOString().substring(0, 10),
      EndDate: null,
      ActualStartDate: "",
      ActualEndDate: "",
      EstimatedTime: 0,
      PriorityId: "",
      TaskStatusId: 5,
      AdminTaskMembers: [],
      TaskMembers: [],
      files: [],
      file: "",
      CommunityId: "",
      AccessLevelId: "",
      ExecutionPercentage: 0,
      // SectorId: "",
      TypeId: "",
      typeId: "",
      Countries: [],
      CountrisId: [],
      TaskImplementRequirementId: "",
    },
    createNewSubTask: {
      Name: "",
      Description: "",
      StartDate: new Date().toISOString().substring(0, 10),
      EndDate: "",
      EstimatedTime: 0,
      TaskStatusId: 5,
      AdminTaskMembers: [],
      CountrisId: [],
      TaskMembers: [],
      files: [],
      file: "",
      ExecutionPercentage: 0,
    },
    addProcedure: {
      Description: "",
      file: "",
      files: [],
      StartDate: new Date().toISOString().substring(0, 10),
      //EndDate: "",
      tempUser: "",
      //TaskStatusId: null,
    },
    addActivityProcedure: {
      Description: "",
      file: "",
      files: [],
      StartDate: new Date().toISOString().substring(0, 10),
      EndDate: "",
      tempUser: "",
      ActivityStatusId: null,
    },
    editSubTaskPopup: {
      Name: pageData?.nameA ?? "",
      Description: pageData?.descriptionA ?? "",
      StartDate:
        pageData?.startDate ?? new Date().toISOString().substring(0, 10),
      EndDate: pageData?.endDate ?? "",
      EstimatedTime: pageData?.estimatedTime ?? 0,
      TaskStatusId: pageData?.taskStatusId ?? "",
      AdminTaskMembers: pageData?.adminmemberIds ?? [],
      CountrisId: pageData?.countrisId ?? [],
      TaskMembers: pageData?.memberIds ?? [],
      ExecutionPercentage: pageData?.executionPercentage ?? 0,
    },
    editPopup: {
      Name: pageData?.nameA ?? "",
      Description: pageData?.descriptionA ?? "",
      StartDate:
        pageData?.startDate ?? new Date().toISOString().substring(0, 10),
      EndDate: pageData?.endDate ?? "",
      ActualStartDate: pageData?.actualStartDate ?? "",
      ActualEndDate: pageData?.actualEndDate ?? "",
      EstimatedTime: pageData?.estimatedTime ?? 0,
      CreateDate: pageData?.createDate ?? undefined,
      PriorityId: pageData?.priorityId ?? "",
      TaskStatusId: pageData?.taskStatusId ?? "",
      AdminTaskMembers: pageData?.adminTaskMembers ?? undefined,
      TaskMembers: pageData?.taskMembers ?? [],
      typeId: pageData?.typeId ?? "",
      ExecutionPercentage: pageData?.executionPercentage ?? 0,
      CommunityId: pageData?.communityId ?? "",
      AccessLevelId: pageData?.accessLevelId ?? "",
      CountrisId: pageData?.countrisId ?? [],
      // SectorId: pageData?.sectorId ?? "",
      TaskImplementRequirementId: pageData?.implementRequirementId ?? "",
    },
    addAttachment: {
      AttachmentFiles: [],
      file: "",
    },
    editProc: {
      Id: pageData?.Id ?? "",
      StartDate:
        pageData?.startDate ?? new Date().toISOString().substring(0, 10),
      EndDate: pageData?.endDate ?? "",
      Description: pageData?.description ?? "",
      UserId: pageData?.memberId ?? "",
    },
    posts: {
      Title: "",
      Description: "",
      Attachment: "",
      MemberId: "",
      CommunityId: "",
      AccessLevelId: "",
      OwnerId: "",
    },
    profilePosts: {
      Title: "",
      Description: "",
      Attachment: "",
      SenderId: "",
      ReceiverId: "",
      IsPrivate: true,
    },
    editProfilePosts: {
      Id: pageData?.id ?? 0,
      Title: pageData?.title ?? "",
      Description: pageData?.description ?? "",
      IsPrivate: pageData?.isPrivate ?? true,
      CreateDate: pageData?.createDate ?? "",
    },
    comment: {
      Description: "",
      Attachment: "",
      ForumId: "",
      MemberId: "",
      OwnerId: "",
    },
    postComment: {
      Description: "",
      Attachment: "",
      MessageId: "",
      MemberId: "",
      OwnerId: "",
    },
    reply: {
      Description: "",
      Attachment: "",
      CommentId: "",
      MemberId: "",
      OwnerId: "",
    },
    //edit Forum
    editForum: {
      Id: pageData?.id ?? 0,
      Title: pageData?.title ?? "",
      Description: pageData?.description ?? "",
    },
  };
};

export const formikSetup = (
  initialValues,
  sourceOfIntailData,
  validationSchema,
  pageName,
  submitFunction,
) => {
  return {
    initialValues: {
      ...initialValues(sourceOfIntailData)[pageName],
    },
    validationSchema: Yup.object({ ...validationSchema(Yup)[pageName] }),
    onSubmit: submitFunction,
  };
};
